/**
 * @desc getFinancialEventJson
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.test.getFinancialEventJson.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getFinancialEventJson`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
